<template>
  <v-card>
    <v-card-title class="primary">
      <span class="headline white--text">{{ $t('preview') }}</span>
      <v-spacer/>
      <Icon
      iconColor="white"
      icon="mdi-close"
      :small="false"
      large
      :tooltipText="$t('close')"
      @icon-clicked="$emit('close')"
      />
    </v-card-title>
    <v-card-text class="pa-0">
      <div class="tract-hud-preview-backdrop d-flex justify-center align-start pa-8">
        <div id="tract-hud-preview">
          <div class="popup-content-container" ref="popup"/>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { tractHudElement, harvestedProgress } from '@/utils/map/TractMarkers.js'
import { TractTypeCategory } from '@/utils/Enumerations.js'

export default {
  name: 'TractHudPreview',

  components: {
    Icon: () => import('@/components/helper/Icon.vue')
  },

  props: {
    sections: {
      type: Array,
      required: true
    }
  },

  computed: {
    exampleTract () {
      const now = new Date()
      return {
        name: this.$t('tractHudExampleName'),
        type: { name: this.$t('tractHudExampleType'), category: TractTypeCategory.Stumpage.value },
        loggingAccessibilityTag: this.$t('tractHudExampleTag'),
        rainfallDataUpdatedOn: now.toISOString(),
        singleDayRainfallInches: 0.42,
        harvestStartDate: new Date(now.getFullYear(), now.getMonth() - 2, 1).toISOString(),
        harvestEndDate: new Date(now.getFullYear(), now.getMonth() + 4, 1).toISOString(),
        harvestedTons: 1240.5,
        expectedTons: 2000
      }
    }
  },

  watch: {
    sections () {
      this.renderHud()
    }
  },

  mounted () {
    this.renderHud()
  },

  methods: {
    renderHud () {
      const hud = tractHudElement(this.exampleTract, harvestedProgress(this.exampleTract), { detailLink: true, sections: this.sections })
      this.$refs.popup.innerHTML = ''
      this.$refs.popup.appendChild(hud)
    }
  }
}
</script>

<style scoped>
.tract-hud-preview-backdrop {
  min-height: 320px;
  background-color: #6b7f5e;
}

.popup-content-container {
  white-space: nowrap;
}
</style>

<style src="@/styles/map-global.css"/>
